import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import toastr from 'toastr';
import Validator from '../../shared/validator';
import Loading from '../../shared/loading';
import parseFailXhr from '../../shared/parse-fail-xhr';
import ErrorBoundary from '../../shared/error-boundary';
import { EMAIL_REGEX } from '../../shared/consts';
import { contactAsContributorAsync, contactAsPartnerAsync } from '../../services/contact-services';

export default class ContactFormSnowflake extends React.Component {
  static propTypes = {
    contactType: PropTypes.oneOf(['contributor', 'partner']).isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleEmailAddressChange = this.handleEmailAddressChange.bind(this);
    this.handleMobilePhoneNumberChange = this.handleMobilePhoneNumberChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.validator = new Validator({
      nameRequired: () => !!this.state.name,
      emailAddressRequired: () => !!this.state.emailAddress,
      emailAddressRegex: () => !this.state.emailAddress
        || EMAIL_REGEX.test(this.state.emailAddress),
      mobilePhoneNumberRequired: () => !!this.state.mobilePhoneNumber,
    }, {
      onValidationChanged: () => {
        this.setState(s => (s.validations = this.validator.getValidations()));
      },
    });
    this.state = {
      name: '',
      emailAddress: '',
      mobilePhoneNumber: '',
    };
    this.state.validations = this.validator.getValidations();
  }

  handleNameChange(event) {
    const name = event.target.value;
    this.setState({ name });
    this.validator.validateNameRequired();
  }

  handleEmailAddressChange(event) {
    const emailAddress = event.target.value;
    this.setState({ emailAddress });
    this.validator.validateEmailAddressRequired();
    this.validator.validateEmailAddressRegex();
  }

  handleMobilePhoneNumberChange(event) {
    const mobilePhoneNumber = event.target.value;
    this.setState({ mobilePhoneNumber });
    this.validator.validateMobilePhoneNumberRequired();
  }

  handleSubmit(event) {
    event.preventDefault();

    if (!this.validator.validateForm().formValid) return;

    this.loading.start();
    const contactMethod = this.props.contactType === 'contributor'
      ? contactAsContributorAsync
      : contactAsPartnerAsync;
    contactMethod(_.pick(this.state, ['name', 'emailAddress', 'mobilePhoneNumber']))
      .done(() => {
        this.setState({
          messageSent: true,
          name: '',
          emailAddress: '',
          mobilePhoneNumber: '',
        });
        this.validator.resetValidation();
        toastr.success('Your message has been sent');
      })
      .fail(xhr => {
        const errors = parseFailXhr(xhr);
        errors.anyUnhandledErrors() && toastr.error(errors.getErrorSummary(), 'Error');
      })
      .always(() => this.loading.stop());
  }

  render() {
    return (
      <ErrorBoundary>
        <form className="wpcf7-form" onSubmit={this.handleSubmit}>
          <Loading ref={e => (this.loading = e)} variant="small">
            <div className="contact-form-snowflake">
              <p className="inner-input">
                <input
                  type="text"
                  placeholder="Name"
                  value={this.state.name}
                  onChange={this.handleNameChange}
                />
                {this.state.validations.nameRequiredValid
                  || <span className="help-block">Name is required</span>}
              </p>
              <p className="inner-input">
                <input
                  type="email"
                  placeholder="Email address"
                  value={this.state.emailAddress}
                  onChange={this.handleEmailAddressChange}
                />
                {this.state.validations.emailAddressRequiredValid
                  || <span className="help-block">Email address is required</span>}
                {this.state.validations.emailAddressRegexValid
                  || <span className="help-block">Email address is invalid</span>}
              </p>
              <p className="inner-input">
                <input
                  type="text"
                  placeholder="Mobile phone number"
                  value={this.state.mobilePhoneNumber}
                  onChange={this.handleMobilePhoneNumberChange}
                />
                {this.state.validations.mobilePhoneNumberRequiredValid
                  || <span className="help-block">Mobile phone number is required</span>}
              </p>
              <p className="contact-submit">
                <input type="submit" className="btn btn-default button submit" value="Submit" />
              </p>
            </div>
          </Loading>
          {!this.state.messageSent
            || (
            <div className="alert alert-success">
              <strong>Success!</strong>
              {' Your message has been sent to the team at Livewire.'}
            </div>
            )}
        </form>
      </ErrorBoundary>
    );
  }
}
